import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import { inject } from '@ember/service';
import getConfig from 'beebee-base/lib/get-config';

var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15;
let FileModel = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _dec4 = attr('string'), _dec5 = attr('string'), _dec6 = attr('boolean'), _dec7 = attr('string'), _dec8 = attr('string'), _dec9 = attr('string'), _dec0 = attr('string'), _dec1 = attr('boolean'), _dec10 = belongsTo('contact', {
  inverse: null,
  async: true
}), _dec11 = belongsTo('contact', {
  inverse: 'files',
  async: true
}), _dec12 = attr('boolean'), _dec13 = hasMany('tag', {
  inverse: null,
  async: false
}), _dec14 = attr('boolean', {
  defaultValue: false
}), _class = class FileModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "session", _descriptor, this);
    _initializerDefineProperty(this, "file_name", _descriptor2, this);
    _initializerDefineProperty(this, "file_type", _descriptor3, this);
    _initializerDefineProperty(this, "file_size", _descriptor4, this);
    _initializerDefineProperty(this, "file_url", _descriptor5, this);
    _initializerDefineProperty(this, "file_etag", _descriptor6, this);
    _initializerDefineProperty(this, "file_public", _descriptor7, this);
    _initializerDefineProperty(this, "notes", _descriptor8, this);
    _initializerDefineProperty(this, "created_at", _descriptor9, this);
    _initializerDefineProperty(this, "thumbnail_url", _descriptor0, this);
    _initializerDefineProperty(this, "upload_date", _descriptor1, this);
    _initializerDefineProperty(this, "signed", _descriptor10, this);
    _initializerDefineProperty(this, "uploader", _descriptor11, this);
    _initializerDefineProperty(this, "contact", _descriptor12, this);
    _initializerDefineProperty(this, "is_thumbnail", _descriptor13, this);
    _initializerDefineProperty(this, "tags", _descriptor14, this);
    _initializerDefineProperty(this, "my_dirty", _descriptor15, this);
  }
  get total_tags_number() {
    return (this.tags || []).length;
  }
  get file_api_url() {
    // Guard missing token (logged out) like the other *_api_url getters,
    // instead of producing an `access_token=null` URL.
    if (!this.session.token || !this.file_url) {
      return null;
    }
    return `${getConfig(this).APP.urlApi}/app/file?access_token=${this.session.token}&url=${encodeURIComponent(this.file_url)}&name=${encodeURIComponent(this.file_name ?? '')}`;
  }
  get thumbnail_api_url() {
    if (!this.session.token || !this.thumbnail_url) {
      return null;
    }
    return `${getConfig(this).APP.urlApi}/app/file?access_token=${this.session.token}&name=${encodeURIComponent(this.file_name ?? '')}&url=${encodeURIComponent(this.thumbnail_url)}`;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "file_name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "file_type", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "file_size", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "file_url", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "file_etag", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "file_public", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "notes", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "created_at", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "thumbnail_url", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "upload_date", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "signed", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "uploader", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "contact", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "is_thumbnail", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "tags", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "my_dirty", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { FileModel as default };
//# sourceMappingURL=file.js.map
